<template>
  <div>
    <div class="w-container">
      <div class="header">
        <div class="header-nav">
          <router-link to="/" class="nav-link">
            <font-awesome-icon icon="chevron-left" />
              &nbsp;&nbsp;戻る
          </router-link>
        </div>
      </div>
    </div> 
    <div class="w-container">
      <b-button size="lg" variant="outline-primary" :to="{ path: '/item-size' }">
        <font-awesome-icon icon="eye" />
          &nbsp;サイズを見る
      </b-button>
    </div>
    <img :src="itemImage" alt="">
    <img :src="dressImage" alt="">
    ID. {{ id }}
    <div class="w-container">
      <b-button size="lg" variant="outline-primary" :to="{ path: '/item-size' }">
        <font-awesome-icon icon="eye" />
          &nbsp;サイズを見る
      </b-button>
    </div>
  </div>
</template>

<script>
export default {
  props: ["id"],
  data() {
    return {
      itemImage: require('../assets/image/items/' + this.id + '.jpg'),
      dressImage: require('../assets/image/items/' + this.id + '.png')
      // itemImage: require('../assets/image/items/16d001-04.jpg') // OK
    }
  },
}
</script>
<style lang="scss" scoped>
.w-container {
  max-width: 768px;
  margin-right: auto;
  margin-left: auto;
  margin-bottom: 10px;
  position: relative;
  clear: both;
}
.header {
  display: flex;
  text-align: left;
  :nth-child(2) {
    text-align: right;
  }
}
.header-nav {
  width: 100%;
  a {
    color: #666;
  }
  &:hover {
  // background-color: rgba(123, 31, 162, .1);
  // background-color:#007bff;
  background-color:#666;
  border-radius: 5px;
  }
  a {
    &:hover {
      color: #fff;
    }
  }
}
.img_page {
  margin: 10px auto;
  width: 100%;
}
</style>
